export const resources = {
  ko: {
    common: {
      korean: "한국어",
      english: "English",
      traditionalChinese: "繁體中文",
      simplifiedChinese: "简体中文",
      loading: "불러오는 중...",
      close: "닫기",
      closeOthers: "다른 탭 모두 닫기",
      refresh: "새로고침",
      noTabs: "열린 탭이 없습니다.",
      search: "검색",
      reset: "초기화",
      add: "등록",
      copy: "복제",
      delete: "삭제",
      cancel: "취소",
      confirm: "확인",
      error: "오류",
      all: "전체",
      selectedDelete: "선택 삭제",
      retry: "다시 시도",
      totalRows: "총 행 수: {{count}}",
      selectedRows: "선택된 행 수: {{count}}",
      details: "{{name}} 상세 정보",
      cellDetailsDescription: "선택한 셀의 전체 데이터입니다.",
      copyCell: "복사하기",
      yes: "예",
      no: "아니요",
      languageChangeFailed: "언어 설정을 저장하지 못했습니다.",
    },
    auth: {
      login: "로그인",
      loginDescription: "시스템에 접속하여 업무를 시작하세요.",
      userId: "사용자 아이디",
      password: "비밀번호",
      passwordPlaceholder: "비밀번호를 입력하세요.",
      rememberUserId: "아이디 저장",
      loggingIn: "로그인 중...",
      logout: "로그아웃",
      logoutConfirm: "로그아웃하시겠습니까?",
      intro: "효율적인 EDI 솔루션으로\n비즈니스 프로세스를 혁신하세요.",
      userIdRequired: "사용자 아이디를 입력하세요.",
      userIdMin: "사용자 아이디는 3자 이상이어야 합니다.",
      userIdMax: "사용자 아이디는 20자 이하여야 합니다.",
      userIdPattern: "영문, 숫자, 밑줄만 사용할 수 있습니다.",
      passwordRequired: "비밀번호를 입력하세요.",
      passwordMin: "비밀번호는 4자 이상이어야 합니다.",
      passwordMax: "비밀번호는 50자 이하여야 합니다.",
      loginFailed: "로그인에 실패했습니다.",
      invalidCredentials: "사용자 아이디 또는 비밀번호가 올바르지 않습니다.",
      serverError: "서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      networkError: "네트워크 연결을 확인해 주세요.",
    },
    profile: {
      title: "내 정보",
      description: "계정 정보를 확인하고 수정할 수 있습니다.",
      account: "계정",
      username: "사용자명",
      empNo: "사번",
      email: "이메일",
      roles: "역할",
      defaultMenu: "기본 메뉴 ID",
      language: "언어",
      currentPassword: "현재 비밀번호",
      newPassword: "신규 비밀번호",
      confirmPassword: "신규 비밀번호 확인",
      save: "저장",
      saving: "저장 중...",
      saved: "내 정보가 저장되었습니다.",
      loadFailed: "내 정보를 불러오지 못했습니다.",
      saveFailed: "내 정보를 저장하지 못했습니다.",
      passwordMismatch: "신규 비밀번호가 일치하지 않습니다.",
      currentPasswordRequired: "비밀번호 변경 시 현재 비밀번호가 필요합니다.",
    },
    menu: {
      search: "메뉴 검색...",
      expand: "메뉴 펼치기",
      collapse: "메뉴 숨기기",
      loadFailed: "메뉴를 불러오지 못했습니다.",
      MENU200: "대시보드",
      MENU000: "시스템 관리",
      MENU100: "EDI 관리",
      MENU300: "CELLO 조회",
      MENU001: "사용자 관리",
      MENU002: "역할 관리",
      MENU003: "메뉴 관리",
      MENU012: "공통코드 관리",
      MENU301: "CELLO 데이터 조회",
      MENU104: "고객사 관리",
      MENU105: "연결 관리",
      MENU115: "TLS 인증서 관리",
      MENU108: "인터페이스 관리",
      MENU109: "스케줄 관리",
      MENU111: "송수신 원문 데이터 관리",
      MENU113: "미확인 수신 데이터 관리",
      MENU116: "송신 대상 관리",
      MENU117: "ACKANS 송신 대상 관리",
      MENU118: "GENRES 조회",
      MENU112: "파서/매퍼 테스트",
    },
    users: {
      title: "사용자 관리",
      keyword: "사용자 ID/이름",
      keywordPlaceholder: "사용자 ID나 이름을 입력하세요.",
      status: "활성화 여부",
      statusPlaceholder: "활성화 여부 선택",
      add: "사용자 등록",
      copy: "사용자 복제",
      selectToCopy: "복제할 사용자를 선택해 주세요.",
      copyOneOnly: "사용자 복제는 한 번에 하나만 가능합니다.",
      selectToDelete: "삭제할 사용자를 선택해 주세요.",
      deleteConfirmTitle: "사용자 삭제 확인",
      deleteConfirm: "선택한 {{count}}명의 사용자를 삭제하시겠습니까?\n\n삭제 대상: {{names}}",
      deleteCompleted: "삭제 완료",
      deleteSuccess: "{{count}}명의 사용자가 삭제되었습니다.",
      deleteResult: "삭제 결과",
      deletePartial: "{{success}}명 삭제 성공, {{fail}}명 삭제 실패\n실패한 사용자는 다시 시도해 주세요.",
      deleteFailed: "사용자 삭제에 실패했습니다.",
      noRows: "등록된 사용자가 없습니다.",
      columns: {
        userId: "사용자 ID",
        username: "사용자명",
        empNo: "사번",
        email: "이메일",
        roles: "역할",
        status: "활성화 여부",
        defaultMenu: "기본 메뉴",
        customer: "고객사",
        language: "언어",
        lastLogin: "최종 로그인",
        createdBy: "등록자",
        createdAt: "등록일시",
        updatedBy: "수정자",
        updatedAt: "수정일시",
      },
    },
    menuAdmin: {
      title: "메뉴 관리",
      keyword: "메뉴명/URL",
      keywordPlaceholder: "메뉴명 또는 URL을 입력하세요.",
      useYn: "사용 여부",
      add: "메뉴 등록",
      permission: "권한 관리",
      component: "컴포넌트",
      iframe: "아이프레임",
      other: "기타",
      active: "활성",
      inactive: "비활성",
      selectAll: "전체 선택 ({{count}}개 선택됨)",
      selectToDelete: "삭제할 메뉴를 선택해 주세요.",
      cannotDeleteParent: "하위 메뉴가 있는 메뉴는 삭제할 수 없습니다. 하위 메뉴를 먼저 삭제해 주세요.",
      deleteConfirmTitle: "메뉴 삭제 확인",
      deleteConfirm: "선택한 {{count}}개의 메뉴를 삭제하시겠습니까?\n\n삭제 대상: {{names}}",
      deleteSuccess: "{{count}}개의 메뉴가 삭제되었습니다.",
      deletePartial: "{{success}}개 삭제 성공, {{fail}}개 삭제 실패\n실패한 메뉴는 다시 시도해 주세요.",
      deleteFailed: "메뉴 삭제에 실패했습니다.",
      noRows: "등록된 메뉴가 없습니다.",
      noSearchResults: "검색 결과가 없습니다.",
      doubleClickEdit: "더블클릭하여 메뉴 수정",
    },
    commonCode: {
      groupCode: "그룹코드",
      groupCodeName: "그룹코드명",
      commonCode: "공통코드",
      commonCodeName: "공통코드명",
      keywordPlaceholder: "그룹코드를 입력하세요.",
      groupManagement: "그룹코드 관리",
      commonManagement: "공통코드 관리",
      addGroup: "그룹코드 등록",
      addCommon: "공통코드 등록",
      description: "설명",
      attribute1: "속성1",
      sortOrder: "순서",
      useYn: "사용 여부",
      noGroups: "등록된 그룹코드가 없습니다.",
      noCodes: "등록된 공통코드가 없습니다.",
      selectGroupFirst: "먼저 그룹코드를 선택해 주세요.",
      selectGroupToDelete: "삭제할 그룹코드를 선택해 주세요.",
      selectCommonToDelete: "삭제할 공통코드를 선택해 주세요.",
      deleteOneGroup: "한 번에 하나의 그룹코드만 삭제할 수 있습니다.",
      deleteOneCommon: "한 번에 하나의 공통코드만 삭제할 수 있습니다.",
      groupDeleteTitle: "그룹코드 삭제 확인",
      commonDeleteTitle: "공통코드 삭제 확인",
      groupDeleteConfirm: "선택한 그룹코드를 삭제하시겠습니까?\n\n삭제 대상: {{name}}",
      commonDeleteConfirm: "선택한 공통코드를 삭제하시겠습니까?\n\n삭제 대상: {{name}}",
      groupDeleted: "그룹코드가 삭제되었습니다.",
      commonDeleted: "공통코드가 삭제되었습니다.",
    },
    grid: {
      noRows: "표시할 데이터가 없습니다.",
      loading: "불러오는 중...",
      page: "페이지",
      more: "더 보기",
      to: "~",
      of: "/",
      next: "다음",
      previous: "이전",
      first: "처음",
      last: "마지막",
    },
    rawDocuments: {
      inboundTitle: "수신 원문 데이터 목록",
      outboundTitle: "송신 원문 데이터 목록",
      inboundTotal: "총 수신 원문 데이터:",
      outboundTotal: "총 송신 원문 데이터:",
      completed: "처리완료:",
      failed: "실패:",
      new: "신규:",
      received: "수신 완료",
      notReceived: "미수신",
      manualRunCount: "수동실행 횟수",
      viewRaw: "원문 확인",
      viewLog: "로그보기",
      viewOutboundRaw: "송신원문보기",
      manualRun: "수동실행",
      delete: "삭제",
      success: "성공",
      error: "오류",
      notSent: "미송신",
      viewError: "오류 내용 보기",
      noErrorDetails: "등록된 오류 상세 내용이 없습니다.",
      inboundTab: "수신 문서",
      outboundTab: "송신 문서",
      customer: "고객사",
      selectCustomer: "고객사를 선택하세요",
      dateRange: "조회기간",
      status: "상태",
      selectStatus: "상태를 선택하세요",
      interface: "인터페이스",
      selectInterface: "인터페이스를 선택하세요",
      messageNoPlaceholder: "Message No.를 입력하세요",
      documentNoPlaceholder: "Document No.를 입력하세요",
      startDate: "시작일",
      endDate: "종료일",
      selectDateTime: "날짜와 시간을 선택해 주세요",
      startDateRequired: "시작일은 필수입니다",
      endDateRequired: "종료일은 필수입니다",
      inputError: "입력 오류",
      loadFailed: "응답 데이터 수신 중 오류가 발생했습니다.",
      documentFunction: "문서기능",
      transmissionStatus: "전송상태",
      sent: "송신 완료",
      failedValue: "실패",
      receivedAt: "수신일시",
      createdAt: "생성일시",
      processedAt: "처리일시",
      sentAt: "송신일시",
      ackansSentAt: "ACKANS 송신일시",
      actions: "제어",
      retrySelected: "선택 일괄재시도",
      runInbound: "수신실행",
      runOutbound: "송신실행",
      noInboundRows: "수신 원문 데이터 목록이 없습니다.",
      noOutboundRows: "송신 원문 데이터 목록이 없습니다.",
      pageSize: "페이지 크기",
      itemsPerPage: "{{count}}개",
      totalCount: "총 {{count}}건",
      errorDetails: "오류 내용",
      outboundErrorDescription: "송신 원문 데이터 처리 실패 오류 내용",
    },
  },
  en: {
    raw: {
      "검색": "Search",
      "초기화": "Reset",
      "등록": "Add",
      "수정": "Edit",
      "삭제": "Delete",
      "원문 확인": "View Raw",
      "상세보기": "View Details",
      "시작": "Start",
      "중지": "Stop",
      "선택 삭제": "Delete Selected",
      "역할 등록": "Add Role",
      "상태 변경": "Change Status",
      "새로고침": "Refresh",
      "다운로드": "Download",
      "닫기": "Close",
      "취소": "Cancel",
      "저장": "Save",
      "전체": "All",
      "활성": "Active",
      "비활성": "Inactive",
      "사용": "Use",
      "사용안함": "Do Not Use",
      "선택없음": "None",
      "고객사": "Customer",
      "고객사 코드/이름": "Customer Code / Name",
      "고객사 코드나 이름을 입력하세요": "Enter a customer code or name",
      "고객사를 선택하세요": "Select a customer",
      "고객사 코드": "Customer Code",
      "회사명": "Company Name",
      "담당자": "Contact",
      "담당자 이메일": "Contact Email",
      "APIKey 발급여부": "API Key Issued",
      "활성화": "Active",
      "등록자": "Created By",
      "등록일시": "Created At",
      "수정자": "Updated By",
      "수정일시": "Updated At",
      "고객사 목록": "Customer List",
      "고객사 등록": "Add Customer",
      "연결명/설명": "Connection Name / Description",
      "연결명이나 설명을 입력하세요": "Enter a connection name or description",
      "연결 ID": "Connection ID",
      "연결명": "Connection Name",
      "접속 프로토콜": "Protocol",
      "인증방법": "Authentication",
      "연결 설정 목록": "Connection List",
      "연결 설정 등록": "Add Connection",
      "인증서명": "Certificate Name",
      "인증서명을 입력하세요": "Enter a certificate name",
      "활성 상태": "Active Status",
      "인증서 ID": "Certificate ID",
      "파일명": "File Name",
      "파일 크기": "File Size",
      "상태": "Status",
      "설명": "Description",
      "제어": "Actions",
      "인증서 등록": "Add Certificate",
      "TLS 인증서 목록": "TLS Certificate List",
      "인터페이스명/문서코드/고객사코드": "Interface / Document / Customer Code",
      "인터페이스명, 문서코드 또는 고객사코드를 입력하세요": "Enter an interface, document, or customer code",
      "인터페이스명": "Interface Name",
      "인터페이스": "Interface",
      "인터페이스 ID": "Interface ID",
      "인터페이스 타입": "Interface Type",
      "인터페이스 상태": "Interface Status",
      "인터페이스 에러": "Interface Error",
      "인터페이스일시": "Interface Date/Time",
      "인터페이스 목록": "Interface List",
      "인터페이스 등록": "Add Interface",
      "문서코드": "Document Code",
      "문서번호": "Document No.",
      "문서일자": "Document Date",
      "연결": "Connection",
      "송/수신여부": "Direction",
      "송/수신": "Direction",
      "송신참조아이디": "Send Reference ID",
      "송신참조ID": "Send Reference ID",
      "송신자": "Sender",
      "수신자": "Receiver",
      "메시지명": "Message Name",
      "기능코드": "Function Code",
      "데이터포맷": "Data Format",
      "스케줄러 사용여부": "Scheduler Enabled",
      "사용여부": "Usage",
      "알림전송여부": "Notification",
      "스케줄 관리": "Schedule Management",
      "스케줄관리": "Schedule Management",
      "스케줄러명": "Scheduler Name",
      "실행주기": "Schedule",
      "스케줄 설정": "Schedule",
      "마지막 실행": "Last Run",
      "다음 실행": "Next Run",
      "마지막실행일시": "Last Run At",
      "다음실행일시": "Next Run At",
      "원문 데이터 목록": "Raw Message List",
      "수신 원문 데이터목록": "Inbound Raw Message List",
      "송신 원문 데이터목록": "Outbound Raw Message List",
      "송수신 구분": "Direction",
      "수신일시": "Received At",
      "송신일시": "Sent At",
      "생성일시": "Created At",
      "처리일시": "Processed At",
      "GENRES 수신": "GENRES Received",
      "수동실행 횟수": "Manual Runs",
      "ACKANS 송신일시": "ACKANS Sent At",
      "처리상태": "Processing Status",
      "미확인 수신 데이터 목록": "Unidentified Message List",
      "미확인 수신데이터 목록": "Unidentified Message List",
      "송신 대상 관리": "Outbound Target Management",
      "ACKANS 송신 대상 관리": "ACKANS Target Management",
      "ACKANS 상태": "ACKANS Status",
      "ACKANS 에러": "ACKANS Error",
      "ACKANS 처리일시": "ACKANS Processed At",
      "GENRES 조회": "GENRES Inquiry",
      "GenRes 목록": "GENRES List",
      "CELLO 데이터 조회": "CELLO Data Inquiry",
      "Cello Data 목록": "CELLO Data List",
      "순번": "No.",
      "처리 내용": "Processing Details",
      "데이터가 없습니다.": "No data available.",
      "등록된 고객사가 없습니다.": "No customers are registered.",
      "등록된 연결 설정이 없습니다.": "No connections are registered.",
      "TLS 인증서 목록이 없습니다.": "No TLS certificates are registered.",
      "등록된 인터페이스가 없습니다.": "No interfaces are registered."
      ,"역할명": "Role Name"
      ,"역할명을 입력하세요": "Enter a role name"
      ,"역할 관리": "Role Management"
      ,"역할 ID": "Role ID"
      ,"역할 ID를 입력하세요": "Enter a role ID"
      ,"등록된 역할이 없습니다.": "No roles are registered."
      ,"총 인증서:": "Total Certificates:"
      ,"활성:": "Active:"
      ,"비활성:": "Inactive:"
      ,"검색어": "Keyword"
      ,"인터페이스명, 문서코드, 고객사코드 등을 입력하세요": "Enter an interface name, document code, or customer code"
      ,"인터페이스명, 문서코드, 고객사 코드를 입력하세요": "Enter an interface name, document code, or customer code"
      ,"총 스케줄러:": "Total Schedulers:"
      ,"실행중:": "Running:"
      ,"중지됨:": "Stopped:"
      ,"가동률:": "Uptime:"
      ,"실행중": "Running"
      ,"중지됨": "Stopped"
      ,"수신 문서": "Inbound Documents"
      ,"송신 문서": "Outbound Documents"
      ,"인터페이스를 선택하세요": "Select an interface"
      ,"인터페이스 ID 직접 입력": "Enter an interface ID directly"
      ,"시작일": "Start Date"
      ,"종료일": "End Date"
      ,"총 수신 원문 데이터:": "Total Inbound Raw Messages:"
      ,"총 송신 원문 데이터:": "Total Outbound Raw Messages:"
      ,"처리완료:": "Completed:"
      ,"실패:": "Failed:"
      ,"신규:": "New:"
      ,"수신 원문 데이터 목록이 없습니다.": "No inbound raw messages."
      ,"송신 원문 데이터 목록이 없습니다.": "No outbound raw messages."
      ,"등록된 미확인 수신데이터가 없습니다.": "No unidentified inbound messages."
      ,"인터페이스 타입을 입력하세요": "Enter an interface type"
      ,"조회기간": "Date Range"
      ,"총 건수:": "Total:"
      ,"개발 도구 - Parser/Mapper 테스트": "Developer Tools - Parser/Mapper Test"
      ,"클래스 선택": "Select Class"
      ,"테스트 실행": "Run Test"
      ,"테스트 중...": "Testing..."
      ,"테스트 Payload *": "Test Payload *"
      ,"파싱할 데이터를 입력하세요...": "Enter data to parse..."
      ,"Parser 테스트": "Parser Test"
      ,"Mapper 테스트": "Mapper Test"
      ,"테이블 선택하세요": "Select a table"
      ,"테이블 선택": "Select Table"
      ,"테이블을 선택하세요": "Select a table"
      ,"상태 새로고침": "Refresh Status"
      ,"모두 시작": "Start All"
      ,"모두 중지": "Stop All"
      ,"선택 일괄재시도": "Retry Selected"
      ,"수신실행": "Run Inbound"
      ,"송신실행": "Run Outbound"
      ,"인터페이스 지정": "Assign Interface"
      ,"관리자 대시보드": "Administrator Dashboard"
      ,"전체 새로고침": "Refresh All"
      ,"오늘 트랜잭션 현황": "Today's Transaction Summary"
      ,"최근 30일 트랜잭션 현황": "Last 30 Days Transaction Summary"
      ,"수신 성공": "Inbound Success"
      ,"수신 실패": "Inbound Failure"
      ,"송신 성공": "Outbound Success"
      ,"송신 실패": "Outbound Failure"
      ,"오늘 수신 성공": "Inbound success today"
      ,"오늘 수신 실패": "Inbound failures today"
      ,"오늘 송신 성공": "Outbound success today"
      ,"오늘 송신 실패": "Outbound failures today"
      ,"월간 수신 성공": "Monthly Inbound Success"
      ,"월간 수신 실패": "Monthly Inbound Failure"
      ,"월간 송신 성공": "Monthly Outbound Success"
      ,"월간 송신 실패": "Monthly Outbound Failure"
      ,"최근 30일 수신 성공": "Inbound success in the last 30 days"
      ,"최근 30일 수신 실패": "Inbound failures in the last 30 days"
      ,"최근 30일 송신 성공": "Outbound success in the last 30 days"
      ,"최근 30일 송신 실패": "Outbound failures in the last 30 days"
      ,"최근 30일 트랜잭션 추이": "Transaction Trend — Last 30 Days"
      ,"일별 수신/송신 트랜잭션 성공/실패 현황입니다.": "Daily inbound and outbound transaction success and failure trends."
      ,"데이터가 없습니다": "No Data"
      ,"표시할 트랜잭션 통계가 없습니다.": "No transaction statistics to display."
      ,"최근 활동": "Recent Activity"
      ,"오늘 발생한 최신 실패 목록입니다.": "Latest failures recorded today."
      ,"모든 시스템이 정상입니다": "All Systems Operational"
      ,"오늘 발생한 실패가 없습니다.": "No failures occurred today."
      ,"오류 메시지 없음": "No error message"
      ,"시스템 상태": "System Status"
      ,"각 모듈별 실시간 상태입니다.": "Real-time status by module."
      ,"전체 시스템": "Overall System"
      ,"장애": "Incident"
      ,"정상": "Normal"
      ,"수신 모듈": "Inbound Module"
      ,"송신 모듈": "Outbound Module"
      ,"오늘 성공": "Success Today"
      ,"오늘 실패": "Failures Today"
      ,"미확인 수신 데이터": "Unidentified Inbound Data"
      ,"라우트가 지정되지 않은 수신 문서 목록입니다.": "Inbound documents without an assigned route."
      ,"모든 문서가 정상 수신되었습니다.": "All documents were received successfully."
      ,"미확인 수신 데이터가 없습니다.": "No unidentified inbound data."
      ,"알 수 없는 인터페이스": "Unknown Interface"
      ,"미분류": "Unclassified"
      ,"인터페이스:": "Interface:"
      ,"수신 일시": "Received At"
      ,"전체 보기": "View All"
      ,"이번 주 GenRes 목록": "This Week's GenRes"
      ,"이번 주 발생한 GenRes 데이터(최신순 5건)입니다.": "The five most recent GenRes records from this week."
      ,"이번 주 데이터가 없습니다.": "No data for this week."
      ,"메시지명 없음": "No message name"
      ,"성공률": "Success Rate"
      ,"건": " records"
      ,"현재 확인이 필요한 문서가": "Documents requiring review:"
      ,"있습니다.": "are pending."
      ,"전체": "All"
      ,"수신완료": "Received"
      ,"파싱 중": "Parsing"
      ,"유효성 검사 중": "Validating"
      ,"매핑 중": "Mapping"
      ,"DB 저장 중": "Saving to DB"
      ,"처리 완료": "Completed"
      ,"데이터생성": "Data Created"
      ,"매핑": "Mapping"
      ,"송신 중": "Sending"
      ,"송신 완료": "Sent"
      ,"ACKANS 성공": "ACKANS Success"
      ,"ACKANS 실패": "ACKANS Failure"
      ,"인터페이스 완료": "Interface Completed"
      ,"처리실패": "Processing Failed"
      ,"성공": "Success"
      ,"에러": "Error"
      ,"컴포넌트": "Component"
      ,"아이프레임": "iFrame"
      ,"수신": "Inbound"
      ,"송신": "Outbound"
      ,"DATABASE인증": "Database Authentication"
      ,"예": "Yes"
      ,"아니오": "No"
      ,"처리완료": "Completed"
      ,"오류": "Error"
      ,"서버 인증(TLS)": "Server Authentication (TLS)"
      ,"인증서를 선택하세요": "Select a certificate"
    },
    common: {
      korean: "한국어",
      english: "English",
      traditionalChinese: "Traditional Chinese",
      simplifiedChinese: "Simplified Chinese",
      loading: "Loading...",
      close: "Close",
      closeOthers: "Close other tabs",
      refresh: "Refresh",
      noTabs: "No tabs are open.",
      search: "Search",
      reset: "Reset",
      add: "Add",
      copyCell: "Copy",
      delete: "Delete",
      cancel: "Cancel",
      confirm: "Confirm",
      error: "Error",
      all: "All",
      selectedDelete: "Delete selected",
      retry: "Try again",
      totalRows: "Total rows: {{count}}",
      selectedRows: "Selected rows: {{count}}",
      details: "{{name}} Details",
      cellDetailsDescription: "Full data for the selected cell.",
      copy: "Copy",
      yes: "Yes",
      no: "No",
      languageChangeFailed: "Failed to save the language preference.",
    },
    auth: {
      login: "Sign in",
      loginDescription: "Sign in to start working.",
      userId: "User ID",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      rememberUserId: "Remember user ID",
      loggingIn: "Signing in...",
      logout: "Sign out",
      logoutConfirm: "Would you like to sign out?",
      intro: "Transform your business processes\nwith an efficient EDI solution.",
      userIdRequired: "Enter your user ID.",
      userIdMin: "User ID must be at least 3 characters.",
      userIdMax: "User ID must be 20 characters or fewer.",
      userIdPattern: "Only letters, numbers, and underscores are allowed.",
      passwordRequired: "Enter your password.",
      passwordMin: "Password must be at least 4 characters.",
      passwordMax: "Password must be 50 characters or fewer.",
      loginFailed: "Sign-in failed.",
      invalidCredentials: "The user ID or password is incorrect.",
      serverError: "A server error occurred. Please try again later.",
      networkError: "Please check your network connection.",
    },
    profile: {
      title: "My Profile",
      description: "View and update your account information.",
      account: "Account",
      username: "User Name",
      empNo: "Employee No.",
      email: "Email",
      roles: "Roles",
      defaultMenu: "Default Menu ID",
      language: "Language",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm New Password",
      save: "Save",
      saving: "Saving...",
      saved: "Your profile has been saved.",
      loadFailed: "Failed to load your profile.",
      saveFailed: "Failed to save your profile.",
      passwordMismatch: "The new passwords do not match.",
      currentPasswordRequired: "Current password is required to change it.",
    },
    menu: {
      search: "Search menus...",
      expand: "Expand menu",
      collapse: "Collapse menu",
      loadFailed: "Failed to load menus.",
      MENU200: "Dashboard",
      MENU000: "System Administration",
      MENU100: "EDI Management",
      MENU300: "CELLO Inquiry",
      MENU001: "User Management",
      MENU002: "Role Management",
      MENU003: "Menu Management",
      MENU012: "Common Code Management",
      MENU301: "CELLO Data Inquiry",
      MENU104: "Customer Management",
      MENU105: "Connection Management",
      MENU115: "TLS Certificate Management",
      MENU108: "Interface Management",
      MENU109: "Schedule Management",
      MENU111: "Raw Message Management",
      MENU113: "Unidentified Message Management",
      MENU116: "Outbound Target Management",
      MENU117: "ACKANS Target Management",
      MENU118: "GENRES Inquiry",
      MENU112: "Parser/Mapper Test",
    },
    users: {
      title: "User Management",
      keyword: "User ID / Name",
      keywordPlaceholder: "Enter a user ID or name.",
      status: "Active Status",
      statusPlaceholder: "Select status",
      add: "Add User",
      copy: "Copy User",
      selectToCopy: "Select a user to copy.",
      copyOneOnly: "Only one user can be copied at a time.",
      selectToDelete: "Select users to delete.",
      deleteConfirmTitle: "Confirm User Deletion",
      deleteConfirm: "Delete {{count}} selected user(s)?\n\nUsers: {{names}}",
      deleteCompleted: "Deletion Complete",
      deleteSuccess: "{{count}} user(s) were deleted.",
      deleteResult: "Deletion Result",
      deletePartial: "{{success}} succeeded, {{fail}} failed.\nPlease retry the failed users.",
      deleteFailed: "Failed to delete users.",
      noRows: "No users are registered.",
      columns: {
        userId: "User ID",
        username: "User Name",
        empNo: "Employee No.",
        email: "Email",
        roles: "Roles",
        status: "Active Status",
        defaultMenu: "Default Menu",
        customer: "Customer",
        language: "Language",
        lastLogin: "Last Login",
        createdBy: "Created By",
        createdAt: "Created At",
        updatedBy: "Updated By",
        updatedAt: "Updated At",
      },
    },
    menuAdmin: {
      title: "Menu Management",
      keyword: "Menu Name / URL",
      keywordPlaceholder: "Enter a menu name or URL.",
      useYn: "Usage",
      add: "Add Menu",
      permission: "Permissions",
      component: "Component",
      iframe: "IFrame",
      other: "Other",
      active: "Active",
      inactive: "Inactive",
      selectAll: "Select all ({{count}} selected)",
      selectToDelete: "Select menus to delete.",
      cannotDeleteParent: "A menu with child menus cannot be deleted. Delete its child menus first.",
      deleteConfirmTitle: "Confirm Menu Deletion",
      deleteConfirm: "Delete {{count}} selected menu(s)?\n\nMenus: {{names}}",
      deleteSuccess: "{{count}} menu(s) were deleted.",
      deletePartial: "{{success}} succeeded, {{fail}} failed.\nPlease retry the failed menus.",
      deleteFailed: "Failed to delete menus.",
      noRows: "No menus are registered.",
      noSearchResults: "No search results.",
      doubleClickEdit: "Double-click to edit the menu",
    },
    commonCode: {
      groupCode: "Group Code",
      groupCodeName: "Group Code Name",
      commonCode: "Common Code",
      commonCodeName: "Common Code Name",
      keywordPlaceholder: "Enter a group code.",
      groupManagement: "Group Code Management",
      commonManagement: "Common Code Management",
      addGroup: "Add Group Code",
      addCommon: "Add Common Code",
      description: "Description",
      attribute1: "Attribute 1",
      sortOrder: "Order",
      useYn: "Usage",
      noGroups: "No group codes are registered.",
      noCodes: "No common codes are registered.",
      selectGroupFirst: "Select a group code first.",
      selectGroupToDelete: "Select a group code to delete.",
      selectCommonToDelete: "Select a common code to delete.",
      deleteOneGroup: "Only one group code can be deleted at a time.",
      deleteOneCommon: "Only one common code can be deleted at a time.",
      groupDeleteTitle: "Confirm Group Code Deletion",
      commonDeleteTitle: "Confirm Common Code Deletion",
      groupDeleteConfirm: "Delete the selected group code?\n\nTarget: {{name}}",
      commonDeleteConfirm: "Delete the selected common code?\n\nTarget: {{name}}",
      groupDeleted: "The group code was deleted.",
      commonDeleted: "The common code was deleted.",
    },
    grid: {
      noRows: "No rows to show.",
      loading: "Loading...",
      page: "Page",
      more: "More",
      to: "to",
      of: "of",
      next: "Next",
      previous: "Previous",
      first: "First",
      last: "Last",
    },
    rawDocuments: {
      inboundTitle: "Inbound Raw Message List",
      outboundTitle: "Outbound Raw Message List",
      inboundTotal: "Total Inbound Raw Messages:",
      outboundTotal: "Total Outbound Raw Messages:",
      completed: "Completed:",
      failed: "Failed:",
      new: "New:",
      received: "Received",
      notReceived: "Not received",
      manualRunCount: "Manual Runs",
      viewRaw: "View Raw",
      viewLog: "View Logs",
      viewOutboundRaw: "View Outbound Raw",
      manualRun: "Run Manually",
      delete: "Delete",
      success: "Success",
      error: "Error",
      notSent: "Not sent",
      viewError: "View Error Details",
      noErrorDetails: "No error details are available.",
      inboundTab: "Inbound Documents",
      outboundTab: "Outbound Documents",
      customer: "Customer",
      selectCustomer: "Select a customer",
      dateRange: "Date Range",
      status: "Status",
      selectStatus: "Select a status",
      interface: "Interface",
      selectInterface: "Select an interface",
      messageNoPlaceholder: "Enter a Message No.",
      documentNoPlaceholder: "Enter a Document No.",
      startDate: "Start Date",
      endDate: "End Date",
      selectDateTime: "Select a date and time.",
      startDateRequired: "Start date is required.",
      endDateRequired: "End date is required.",
      inputError: "Input Error",
      loadFailed: "An error occurred while loading the response data.",
      documentFunction: "Document Function",
      transmissionStatus: "Transmission Status",
      sent: "Sent",
      failedValue: "Failed",
      receivedAt: "Received At",
      createdAt: "Created At",
      processedAt: "Processed At",
      sentAt: "Sent At",
      ackansSentAt: "ACKANS Sent At",
      actions: "Actions",
      retrySelected: "Retry Selected",
      runInbound: "Run Inbound",
      runOutbound: "Run Outbound",
      noInboundRows: "No inbound raw messages.",
      noOutboundRows: "No outbound raw messages.",
      pageSize: "Page size",
      itemsPerPage: "{{count}} items",
      totalCount: "Total {{count}} items",
      errorDetails: "Error Details",
      outboundErrorDescription: "Outbound raw message processing error details",
    },
  },
};

resources["zh-tw"] = {
  ...resources.en,
  common: {
    ...resources.en.common,
    korean: "韓文",
    english: "英文",
    traditionalChinese: "繁體中文",
    simplifiedChinese: "简体中文",
    loading: "載入中...",
    close: "關閉",
    closeOthers: "關閉其他分頁",
    refresh: "重新整理",
    noTabs: "目前沒有開啟的分頁。",
    search: "搜尋",
    reset: "重設",
    add: "新增",
    copy: "複製",
    delete: "刪除",
    cancel: "取消",
    confirm: "確認",
    error: "錯誤",
    all: "全部",
    selectedDelete: "刪除所選項目",
    retry: "重試",
    totalRows: "總列數：{{count}}",
    selectedRows: "已選列數：{{count}}",
    details: "{{name}} 詳細資訊",
    cellDetailsDescription: "所選儲存格的完整資料。",
    copyCell: "複製",
    yes: "是",
    no: "否",
    languageChangeFailed: "無法儲存語言設定。",
  },
  auth: {
    ...resources.en.auth,
    login: "登入",
    loginDescription: "請登入以開始工作。",
    userId: "使用者 ID",
    password: "密碼",
    passwordPlaceholder: "請輸入密碼",
    rememberUserId: "記住使用者 ID",
    loggingIn: "登入中...",
    logout: "登出",
    logoutConfirm: "確定要登出嗎？",
    intro: "透過高效的 EDI 解決方案\n革新您的業務流程。",
    userIdRequired: "請輸入使用者 ID。",
    userIdMin: "使用者 ID 至少需要 3 個字元。",
    userIdMax: "使用者 ID 不得超過 20 個字元。",
    userIdPattern: "僅可使用英文字母、數字及底線。",
    passwordRequired: "請輸入密碼。",
    passwordMin: "密碼至少需要 4 個字元。",
    passwordMax: "密碼不得超過 50 個字元。",
    loginFailed: "登入失敗。",
    invalidCredentials: "使用者 ID 或密碼不正確。",
    serverError: "伺服器發生錯誤，請稍後再試。",
    networkError: "請確認網路連線。",
  },
  profile: {
    ...resources.en.profile,
    title: "我的資料",
    description: "檢視及修改帳戶資訊。",
    account: "帳戶",
    username: "使用者名稱",
    empNo: "員工編號",
    email: "電子郵件",
    roles: "角色",
    defaultMenu: "預設選單 ID",
    language: "語言",
    currentPassword: "目前密碼",
    newPassword: "新密碼",
    confirmPassword: "確認新密碼",
    save: "儲存",
    saving: "儲存中...",
    saved: "個人資料已儲存。",
    loadFailed: "無法載入個人資料。",
    saveFailed: "無法儲存個人資料。",
    passwordMismatch: "新密碼不一致。",
    currentPasswordRequired: "變更密碼時必須輸入目前密碼。",
  },
  menu: {
    ...resources.en.menu,
    search: "搜尋選單...",
    expand: "展開選單",
    collapse: "收合選單",
    loadFailed: "無法載入選單。",
    MENU200: "儀表板",
    MENU000: "系統管理",
    MENU100: "EDI 管理",
    MENU300: "CELLO 查詢",
    MENU001: "使用者管理",
    MENU002: "角色管理",
    MENU003: "選單管理",
    MENU012: "共用代碼管理",
    MENU301: "CELLO 資料查詢",
    MENU104: "客戶管理",
    MENU105: "連線管理",
    MENU115: "TLS 憑證管理",
    MENU108: "介面管理",
    MENU109: "排程管理",
    MENU111: "原始訊息管理",
    MENU113: "未識別訊息管理",
    MENU116: "傳送目標管理",
    MENU117: "ACKANS 目標管理",
    MENU118: "GENRES 查詢",
    MENU112: "Parser/Mapper 測試",
  },
  users: {
    ...resources.en.users,
    title: "使用者管理",
    keyword: "使用者 ID／名稱",
    keywordPlaceholder: "請輸入使用者 ID 或名稱。",
    status: "啟用狀態",
    statusPlaceholder: "選擇狀態",
    add: "新增使用者",
    copy: "複製使用者",
    selectToCopy: "請選擇要複製的使用者。",
    copyOneOnly: "一次只能複製一位使用者。",
    selectToDelete: "請選擇要刪除的使用者。",
    deleteConfirmTitle: "確認刪除使用者",
    deleteConfirm: "確定刪除所選的 {{count}} 位使用者嗎？\n\n使用者：{{names}}",
    deleteCompleted: "刪除完成",
    deleteSuccess: "已刪除 {{count}} 位使用者。",
    deleteResult: "刪除結果",
    deletePartial: "成功 {{success}} 位，失敗 {{fail}} 位。\n請重試失敗的使用者。",
    deleteFailed: "刪除使用者失敗。",
    noRows: "尚未登錄使用者。",
    columns: {
      ...resources.en.users.columns,
      userId: "使用者 ID",
      username: "使用者名稱",
      empNo: "員工編號",
      email: "電子郵件",
      roles: "角色",
      status: "啟用狀態",
      defaultMenu: "預設選單",
      customer: "客戶",
      language: "語言",
      lastLogin: "最後登入",
      createdBy: "建立者",
      createdAt: "建立時間",
      updatedBy: "修改者",
      updatedAt: "修改時間",
    },
  },
  menuAdmin: {
    ...resources.en.menuAdmin,
    title: "選單管理",
    keyword: "選單名稱／URL",
    keywordPlaceholder: "請輸入選單名稱或 URL。",
    useYn: "使用狀態",
    add: "新增選單",
    permission: "權限管理",
    component: "元件",
    iframe: "IFrame",
    other: "其他",
    active: "啟用",
    inactive: "停用",
    selectAll: "全選（已選 {{count}} 項）",
    selectToDelete: "請選擇要刪除的選單。",
    cannotDeleteParent: "含有子選單的選單無法刪除，請先刪除子選單。",
    deleteConfirmTitle: "確認刪除選單",
    deleteConfirm: "確定刪除所選的 {{count}} 個選單嗎？\n\n選單：{{names}}",
    deleteSuccess: "已刪除 {{count}} 個選單。",
    deletePartial: "成功 {{success}} 個，失敗 {{fail}} 個。\n請重試失敗的選單。",
    deleteFailed: "刪除選單失敗。",
    noRows: "尚未登錄選單。",
    noSearchResults: "沒有搜尋結果。",
    doubleClickEdit: "按兩下以編輯選單",
  },
  commonCode: {
    ...resources.en.commonCode,
    groupCode: "群組代碼",
    groupCodeName: "群組代碼名稱",
    commonCode: "共用代碼",
    commonCodeName: "共用代碼名稱",
    keywordPlaceholder: "請輸入群組代碼。",
    groupManagement: "群組代碼管理",
    commonManagement: "共用代碼管理",
    addGroup: "新增群組代碼",
    addCommon: "新增共用代碼",
    description: "說明",
    attribute1: "屬性 1",
    sortOrder: "順序",
    useYn: "使用狀態",
    noGroups: "尚未登錄群組代碼。",
    noCodes: "尚未登錄共用代碼。",
    selectGroupFirst: "請先選擇群組代碼。",
    selectGroupToDelete: "請選擇要刪除的群組代碼。",
    selectCommonToDelete: "請選擇要刪除的共用代碼。",
    deleteOneGroup: "一次只能刪除一個群組代碼。",
    deleteOneCommon: "一次只能刪除一個共用代碼。",
    groupDeleteTitle: "確認刪除群組代碼",
    commonDeleteTitle: "確認刪除共用代碼",
    groupDeleteConfirm: "確定刪除所選群組代碼嗎？\n\n目標：{{name}}",
    commonDeleteConfirm: "確定刪除所選共用代碼嗎？\n\n目標：{{name}}",
    groupDeleted: "群組代碼已刪除。",
    commonDeleted: "共用代碼已刪除。",
  },
  grid: {
    ...resources.en.grid,
    noRows: "沒有可顯示的資料。",
    loading: "載入中...",
    page: "頁",
    more: "更多",
    to: "至",
    of: "共",
    next: "下一頁",
    previous: "上一頁",
    first: "第一頁",
    last: "最後一頁",
  },
  rawDocuments: {
    ...resources.en.rawDocuments,
    inboundTitle: "接收原始訊息清單",
    outboundTitle: "傳送原始訊息清單",
    inboundTotal: "接收原始訊息總數：",
    outboundTotal: "傳送原始訊息總數：",
    completed: "處理完成：",
    failed: "失敗：",
    new: "新增：",
    received: "已接收",
    notReceived: "未接收",
    manualRunCount: "手動執行次數",
    viewRaw: "查看原文",
    viewLog: "查看日誌",
    viewOutboundRaw: "查看傳送原文",
    manualRun: "手動執行",
    delete: "刪除",
    success: "成功",
    error: "錯誤",
    notSent: "未傳送",
    viewError: "查看錯誤內容",
      noErrorDetails: "沒有可用的錯誤詳細資料。",
      inboundTab: "接收文件",
      outboundTab: "傳送文件",
      customer: "客戶",
      selectCustomer: "請選擇客戶",
      dateRange: "查詢期間",
      status: "狀態",
      selectStatus: "請選擇狀態",
      interface: "介面",
      selectInterface: "請選擇介面",
      messageNoPlaceholder: "請輸入 Message No.",
      documentNoPlaceholder: "請輸入 Document No.",
      startDate: "開始日期",
      endDate: "結束日期",
      selectDateTime: "請選擇日期與時間。",
      startDateRequired: "開始日期為必填。",
      endDateRequired: "結束日期為必填。",
      inputError: "輸入錯誤",
      loadFailed: "載入回應資料時發生錯誤。",
      documentFunction: "文件功能",
      transmissionStatus: "傳送狀態",
      sent: "傳送完成",
      failedValue: "失敗",
      receivedAt: "接收時間",
      createdAt: "建立時間",
      processedAt: "處理時間",
      sentAt: "傳送時間",
      ackansSentAt: "ACKANS 傳送時間",
      actions: "操作",
      retrySelected: "重試所選項目",
      runInbound: "執行接收",
      runOutbound: "執行傳送",
      noInboundRows: "沒有接收原始訊息。",
      noOutboundRows: "沒有傳送原始訊息。",
      pageSize: "每頁筆數",
      itemsPerPage: "{{count}} 筆",
      totalCount: "共 {{count}} 筆",
      errorDetails: "錯誤內容",
      outboundErrorDescription: "傳送原始訊息處理失敗的錯誤內容",
  },
  raw: {
    ...resources.en.raw,
    "검색": "搜尋",
    "초기화": "重設",
    "등록": "新增",
    "수정": "修改",
    "삭제": "刪除",
    "원문 확인": "查看原文",
    "상세보기": "查看詳細資料",
    "시작": "啟動",
    "중지": "停止",
    "선택 삭제": "刪除所選項目",
    "역할 등록": "新增角色",
    "상태 변경": "變更狀態",
    "새로고침": "重新整理",
    "다운로드": "下載",
    "닫기": "關閉",
    "취소": "取消",
    "저장": "儲存",
    "전체": "全部",
    "활성": "啟用",
    "비활성": "停用",
    "사용": "使用",
    "사용안함": "不使用",
    "선택없음": "未選擇",
    "고객사": "客戶",
    "고객사 코드/이름": "客戶代碼／名稱",
    "고객사 코드나 이름을 입력하세요": "請輸入客戶代碼或名稱",
    "고객사를 선택하세요": "請選擇客戶",
    "고객사 코드": "客戶代碼",
    "회사명": "公司名稱",
    "담당자": "聯絡人",
    "담당자 이메일": "聯絡人電子郵件",
    "활성화": "啟用",
    "등록자": "建立者",
    "등록일시": "建立時間",
    "수정자": "修改者",
    "수정일시": "修改時間",
    "설명": "說明",
    "사용여부": "使用狀態",
    "역할명": "角色名稱",
    "역할명을 입력하세요": "請輸入角色名稱",
    "역할 관리": "角色管理",
    "역할 ID": "角色 ID",
    "등록된 역할이 없습니다.": "尚未登錄角色。",
    "등록된 고객사가 없습니다.": "尚未登錄客戶。",
    "등록된 연결 설정이 없습니다.": "尚未登錄連線設定。",
    "TLS 인증서 목록이 없습니다.": "尚未登錄 TLS 憑證。",
    "등록된 인터페이스가 없습니다.": "尚未登錄介面。",
    "등록된 미확인 수신데이터가 없습니다.": "沒有未識別的接收資料。",
    "데이터가 없습니다.": "沒有資料。",
    "고객사 목록": "客戶清單",
    "연결 설정 목록": "連線設定清單",
    "인터페이스 목록": "介面清單",
    "TLS 인증서 목록": "TLS 憑證清單",
    "인증서명": "憑證名稱",
    "총 인증서:": "憑證總數：",
    "활성:": "啟用：",
    "비활성:": "停用：",
    "검색어": "關鍵字",
    "인터페이스명, 문서코드, 고객사 코드를 입력하세요": "請輸入介面名稱、文件代碼或客戶代碼",
    "총 스케줄러:": "排程總數：",
    "실행중:": "執行中：",
    "중지됨:": "已停止：",
    "가동률:": "運作率：",
    "상태 새로고침": "重新整理狀態",
    "모두 시작": "全部啟動",
    "모두 중지": "全部停止",
    "수신 문서": "接收文件",
    "송신 문서": "傳送文件",
    "인터페이스를 선택하세요": "請選擇介面",
    "인터페이스 ID 직접 입력": "直接輸入介面 ID",
    "시작일": "開始日期",
    "종료일": "結束日期",
    "선택 일괄재시도": "重試所選項目",
    "수신실행": "執行接收",
    "송신실행": "執行傳送",
    "인터페이스 지정": "指定介面",
    "수신 원문 데이터 목록이 없습니다.": "沒有接收原始訊息。",
    "송신 원문 데이터 목록이 없습니다.": "沒有傳送原始訊息。",
    "인터페이스 타입을 입력하세요": "請輸入介面類型",
    "조회기간": "查詢期間",
    "총 건수:": "總筆數：",
    "개발 도구 - Parser/Mapper 테스트": "開發工具 - Parser/Mapper 測試",
    "클래스 선택": "選擇類別",
    "테스트 실행": "執行測試",
    "테스트 중...": "測試中...",
    "테스트 Payload *": "測試 Payload *",
    "파싱할 데이터를 입력하세요...": "請輸入要解析的資料...",
    "Parser 테스트": "Parser 測試",
    "Mapper 테스트": "Mapper 測試",
    "테이블 선택하세요": "請選擇資料表",
    "테이블 선택": "選擇資料表",
    "테이블을 선택하세요": "請選擇資料表",
    "관리자 대시보드": "管理員儀表板",
    "전체 새로고침": "全部重新整理",
    "오늘 트랜잭션 현황": "今日交易狀態",
    "최근 30일 트랜잭션 현황": "最近 30 天交易狀態",
    "수신 성공": "接收成功",
    "수신 실패": "接收失敗",
    "송신 성공": "傳送成功",
    "송신 실패": "傳送失敗",
    "오늘 수신 성공": "今日接收成功",
    "오늘 수신 실패": "今日接收失敗",
    "오늘 송신 성공": "今日傳送成功",
    "오늘 송신 실패": "今日傳送失敗",
    "월간 수신 성공": "每月接收成功",
    "월간 수신 실패": "每月接收失敗",
    "월간 송신 성공": "每月傳送成功",
    "월간 송신 실패": "每月傳送失敗",
    "최근 30일 수신 성공": "最近 30 天接收成功",
    "최근 30일 수신 실패": "最近 30 天接收失敗",
    "최근 30일 송신 성공": "最近 30 天傳送成功",
    "최근 30일 송신 실패": "最近 30 天傳送失敗",
    "최근 30일 트랜잭션 추이": "最近 30 天交易趨勢",
    "일별 수신/송신 트랜잭션 성공/실패 현황입니다.": "每日接收與傳送交易的成功及失敗狀態。",
    "데이터가 없습니다": "沒有資料",
    "표시할 트랜잭션 통계가 없습니다.": "沒有可顯示的交易統計資料。",
    "최근 활동": "最近活動",
    "오늘 발생한 최신 실패 목록입니다.": "今日最新失敗清單。",
    "모든 시스템이 정상입니다": "所有系統運作正常",
    "오늘 발생한 실패가 없습니다.": "今日沒有發生失敗。",
    "오류 메시지 없음": "沒有錯誤訊息",
    "시스템 상태": "系統狀態",
    "각 모듈별 실시간 상태입니다.": "各模組的即時狀態。",
    "전체 시스템": "整體系統",
    "장애": "異常",
    "정상": "正常",
    "수신 모듈": "接收模組",
    "송신 모듈": "傳送模組",
    "오늘 성공": "今日成功",
    "오늘 실패": "今日失敗",
    "미확인 수신 데이터": "未識別接收資料",
    "라우트가 지정되지 않은 수신 문서 목록입니다.": "尚未指定路由的接收文件清單。",
    "모든 문서가 정상 수신되었습니다.": "所有文件皆已成功接收。",
    "미확인 수신 데이터가 없습니다.": "沒有未識別接收資料。",
    "알 수 없는 인터페이스": "未知介面",
    "미분류": "未分類",
    "인터페이스:": "介面：",
    "수신 일시": "接收時間",
    "전체 보기": "檢視全部",
    "이번 주 GenRes 목록": "本週 GenRes 清單",
    "이번 주 발생한 GenRes 데이터(최신순 5건)입니다.": "本週最新的 5 筆 GenRes 資料。",
    "이번 주 데이터가 없습니다.": "本週沒有資料。",
    "메시지명 없음": "沒有訊息名稱",
    "성공률": "成功率",
    "건": " 筆",
    "현재 확인이 필요한 문서가": "目前需要確認的文件有",
    "있습니다.": "。",
    "전체": "全部",
    "수신완료": "接收完成",
    "파싱 중": "解析中",
    "유효성 검사 중": "驗證中",
    "매핑 중": "映射中",
    "DB 저장 중": "儲存至資料庫中",
    "처리 완료": "處理完成",
    "데이터생성": "資料已建立",
    "매핑": "映射",
    "송신 중": "傳送中",
    "송신 완료": "傳送完成",
    "ACKANS 성공": "ACKANS 成功",
    "ACKANS 실패": "ACKANS 失敗",
    "인터페이스 완료": "介面處理完成",
    "처리실패": "處理失敗",
    "성공": "成功",
    "에러": "錯誤",
    "컴포넌트": "元件",
    "아이프레임": "內嵌框架",
    "수신": "接收",
    "송신": "傳送",
    "DATABASE인증": "資料庫驗證",
    "예": "是",
    "아니오": "否",
    "처리완료": "處理完成",
    "오류": "錯誤",
    "서버 인증(TLS)": "伺服器驗證 (TLS)",
    "인증서를 선택하세요": "請選擇憑證",
  },
};

resources["zh-cn"] = {
  ...resources["zh-tw"],
  common: {
    ...resources["zh-tw"].common,
    korean: "韩文",
    english: "英文",
    traditionalChinese: "繁体中文",
    simplifiedChinese: "简体中文",
    loading: "加载中...",
    close: "关闭",
    closeOthers: "关闭其他标签页",
    refresh: "刷新",
    noTabs: "当前没有打开的标签页。",
    search: "搜索",
    reset: "重置",
    add: "新增",
    copy: "复制",
    delete: "删除",
    cancel: "取消",
    confirm: "确认",
    error: "错误",
    all: "全部",
    selectedDelete: "删除所选项目",
    retry: "重试",
    totalRows: "总行数：{{count}}",
    selectedRows: "已选行数：{{count}}",
    details: "{{name}} 详细信息",
    cellDetailsDescription: "所选单元格的完整数据。",
    copyCell: "复制",
    yes: "是",
    no: "否",
    languageChangeFailed: "无法保存语言设置。",
  },
  auth: {
    ...resources["zh-tw"].auth,
    login: "登录",
    loginDescription: "请登录以开始工作。",
    userId: "用户 ID",
    password: "密码",
    passwordPlaceholder: "请输入密码",
    rememberUserId: "记住用户 ID",
    loggingIn: "登录中...",
    logout: "退出登录",
    logoutConfirm: "确定要退出登录吗？",
    intro: "通过高效的 EDI 解决方案\n革新您的业务流程。",
    userIdRequired: "请输入用户 ID。",
    userIdMin: "用户 ID 至少需要 3 个字符。",
    userIdMax: "用户 ID 不得超过 20 个字符。",
    userIdPattern: "只能使用英文字母、数字和下划线。",
    passwordRequired: "请输入密码。",
    passwordMin: "密码至少需要 4 个字符。",
    passwordMax: "密码不得超过 50 个字符。",
    loginFailed: "登录失败。",
    invalidCredentials: "用户 ID 或密码不正确。",
    serverError: "服务器发生错误，请稍后重试。",
    networkError: "请检查网络连接。",
  },
  profile: {
    ...resources["zh-tw"].profile,
    title: "我的资料",
    description: "查看和修改账户信息。",
    account: "账户",
    username: "用户名",
    empNo: "员工编号",
    email: "电子邮件",
    roles: "角色",
    defaultMenu: "默认菜单 ID",
    language: "语言",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmPassword: "确认新密码",
    save: "保存",
    saving: "保存中...",
    saved: "个人资料已保存。",
    loadFailed: "无法加载个人资料。",
    saveFailed: "无法保存个人资料。",
    passwordMismatch: "新密码不一致。",
    currentPasswordRequired: "修改密码时必须输入当前密码。",
  },
  menu: {
    ...resources["zh-tw"].menu,
    search: "搜索菜单...",
    expand: "展开菜单",
    collapse: "收起菜单",
    loadFailed: "无法加载菜单。",
    MENU200: "仪表板",
    MENU000: "系统管理",
    MENU100: "EDI 管理",
    MENU300: "CELLO 查询",
    MENU001: "用户管理",
    MENU002: "角色管理",
    MENU003: "菜单管理",
    MENU012: "公共代码管理",
    MENU301: "CELLO 数据查询",
    MENU104: "客户管理",
    MENU105: "连接管理",
    MENU115: "TLS 证书管理",
    MENU108: "接口管理",
    MENU109: "调度管理",
    MENU111: "原始消息管理",
    MENU113: "未识别消息管理",
    MENU116: "发送目标管理",
    MENU117: "ACKANS 目标管理",
    MENU118: "GENRES 查询",
    MENU112: "Parser/Mapper 测试",
  },
  users: {
    ...resources["zh-tw"].users,
    title: "用户管理",
    keyword: "用户 ID／名称",
    keywordPlaceholder: "请输入用户 ID 或名称。",
    status: "启用状态",
    statusPlaceholder: "选择状态",
    add: "新增用户",
    copy: "复制用户",
    selectToCopy: "请选择要复制的用户。",
    copyOneOnly: "一次只能复制一位用户。",
    selectToDelete: "请选择要删除的用户。",
    deleteConfirmTitle: "确认删除用户",
    deleteConfirm: "确定删除所选的 {{count}} 位用户吗？\n\n用户：{{names}}",
    deleteCompleted: "删除完成",
    deleteSuccess: "已删除 {{count}} 位用户。",
    deleteResult: "删除结果",
    deletePartial: "成功 {{success}} 位，失败 {{fail}} 位。\n请重试失败的用户。",
    deleteFailed: "删除用户失败。",
    noRows: "尚未登记用户。",
    columns: {
      ...resources["zh-tw"].users.columns,
      userId: "用户 ID",
      username: "用户名",
      empNo: "员工编号",
      email: "电子邮件",
      roles: "角色",
      status: "启用状态",
      defaultMenu: "默认菜单",
      customer: "客户",
      language: "语言",
      lastLogin: "最后登录",
      createdBy: "创建者",
      createdAt: "创建时间",
      updatedBy: "修改者",
      updatedAt: "修改时间",
    },
  },
  menuAdmin: {
    ...resources["zh-tw"].menuAdmin,
    title: "菜单管理",
    keyword: "菜单名称／URL",
    keywordPlaceholder: "请输入菜单名称或 URL。",
    useYn: "使用状态",
    add: "新增菜单",
    permission: "权限管理",
    component: "组件",
    iframe: "IFrame",
    other: "其他",
    active: "启用",
    inactive: "停用",
    selectAll: "全选（已选 {{count}} 项）",
    selectToDelete: "请选择要删除的菜单。",
    cannotDeleteParent: "包含子菜单的菜单无法删除，请先删除子菜单。",
    deleteConfirmTitle: "确认删除菜单",
    deleteConfirm: "确定删除所选的 {{count}} 个菜单吗？\n\n菜单：{{names}}",
    deleteSuccess: "已删除 {{count}} 个菜单。",
    deletePartial: "成功 {{success}} 个，失败 {{fail}} 个。\n请重试失败的菜单。",
    deleteFailed: "删除菜单失败。",
    noRows: "尚未登记菜单。",
    noSearchResults: "没有搜索结果。",
    doubleClickEdit: "双击以编辑菜单",
  },
  commonCode: {
    ...resources["zh-tw"].commonCode,
    groupCode: "组代码",
    groupCodeName: "组代码名称",
    commonCode: "公共代码",
    commonCodeName: "公共代码名称",
    keywordPlaceholder: "请输入组代码。",
    groupManagement: "组代码管理",
    commonManagement: "公共代码管理",
    addGroup: "新增组代码",
    addCommon: "新增公共代码",
    description: "说明",
    attribute1: "属性 1",
    sortOrder: "顺序",
    useYn: "使用状态",
    noGroups: "尚未登记组代码。",
    noCodes: "尚未登记公共代码。",
    selectGroupFirst: "请先选择组代码。",
    selectGroupToDelete: "请选择要删除的组代码。",
    selectCommonToDelete: "请选择要删除的公共代码。",
    deleteOneGroup: "一次只能删除一个组代码。",
    deleteOneCommon: "一次只能删除一个公共代码。",
    groupDeleteTitle: "确认删除组代码",
    commonDeleteTitle: "确认删除公共代码",
    groupDeleteConfirm: "确定删除所选组代码吗？\n\n目标：{{name}}",
    commonDeleteConfirm: "确定删除所选公共代码吗？\n\n目标：{{name}}",
    groupDeleted: "组代码已删除。",
    commonDeleted: "公共代码已删除。",
  },
  grid: {
    ...resources["zh-tw"].grid,
    noRows: "没有可显示的数据。",
    loading: "加载中...",
    page: "页",
    more: "更多",
    to: "至",
    of: "共",
    next: "下一页",
    previous: "上一页",
    first: "第一页",
    last: "最后一页",
  },
  rawDocuments: {
    ...resources["zh-tw"].rawDocuments,
    inboundTitle: "接收原始消息列表",
    outboundTitle: "发送原始消息列表",
    inboundTotal: "接收原始消息总数：",
    outboundTotal: "发送原始消息总数：",
    completed: "处理完成：",
    failed: "失败：",
    new: "新增：",
    received: "已接收",
    notReceived: "未接收",
    manualRunCount: "手动执行次数",
    viewRaw: "查看原文",
    viewLog: "查看日志",
    viewOutboundRaw: "查看发送原文",
    manualRun: "手动执行",
    delete: "删除",
    success: "成功",
    error: "错误",
    notSent: "未发送",
    viewError: "查看错误详情",
      noErrorDetails: "没有可用的错误详情。",
      inboundTab: "接收文档",
      outboundTab: "发送文档",
      customer: "客户",
      selectCustomer: "请选择客户",
      dateRange: "查询期间",
      status: "状态",
      selectStatus: "请选择状态",
      interface: "接口",
      selectInterface: "请选择接口",
      messageNoPlaceholder: "请输入 Message No.",
      documentNoPlaceholder: "请输入 Document No.",
      startDate: "开始日期",
      endDate: "结束日期",
      selectDateTime: "请选择日期和时间。",
      startDateRequired: "开始日期为必填项。",
      endDateRequired: "结束日期为必填项。",
      inputError: "输入错误",
      loadFailed: "加载响应数据时发生错误。",
      documentFunction: "文档功能",
      transmissionStatus: "发送状态",
      sent: "发送完成",
      failedValue: "失败",
      receivedAt: "接收时间",
      createdAt: "创建时间",
      processedAt: "处理时间",
      sentAt: "发送时间",
      ackansSentAt: "ACKANS 发送时间",
      actions: "操作",
      retrySelected: "重试所选项目",
      runInbound: "执行接收",
      runOutbound: "执行发送",
      noInboundRows: "没有接收原始消息。",
      noOutboundRows: "没有发送原始消息。",
      pageSize: "每页条数",
      itemsPerPage: "{{count}} 条",
      totalCount: "共 {{count}} 条",
      errorDetails: "错误内容",
      outboundErrorDescription: "发送原始消息处理失败的错误内容",
  },
  raw: {
    ...resources["zh-tw"].raw,
    "검색": "搜索",
    "초기화": "重置",
    "등록": "新增",
    "수정": "修改",
    "삭제": "删除",
    "원문 확인": "查看原文",
    "상세보기": "查看详情",
    "시작": "启动",
    "중지": "停止",
    "선택 삭제": "删除所选项目",
    "역할 등록": "新增角色",
    "상태 변경": "更改状态",
    "새로고침": "刷新",
    "다운로드": "下载",
    "닫기": "关闭",
    "취소": "取消",
    "저장": "保存",
    "전체": "全部",
    "활성": "启用",
    "비활성": "停用",
    "사용": "使用",
    "사용안함": "不使用",
    "선택없음": "未选择",
    "고객사": "客户",
    "고객사 코드/이름": "客户代码／名称",
    "고객사 코드나 이름을 입력하세요": "请输入客户代码或名称",
    "고객사를 선택하세요": "请选择客户",
    "고객사 코드": "客户代码",
    "회사명": "公司名称",
    "담당자": "联系人",
    "담당자 이메일": "联系人电子邮件",
    "활성화": "启用",
    "등록자": "创建者",
    "등록일시": "创建时间",
    "수정자": "修改者",
    "수정일시": "修改时间",
    "설명": "说明",
    "사용여부": "使用状态",
    "역할명": "角色名称",
    "역할명을 입력하세요": "请输入角色名称",
    "역할 관리": "角色管理",
    "역할 ID": "角色 ID",
    "등록된 역할이 없습니다.": "尚未登记角色。",
    "등록된 고객사가 없습니다.": "尚未登记客户。",
    "등록된 연결 설정이 없습니다.": "尚未登记连接设置。",
    "TLS 인증서 목록이 없습니다.": "尚未登记 TLS 证书。",
    "등록된 인터페이스가 없습니다.": "尚未登记接口。",
    "등록된 미확인 수신데이터가 없습니다.": "没有未识别的接收数据。",
    "데이터가 없습니다.": "没有数据。",
    "고객사 목록": "客户列表",
    "연결 설정 목록": "连接设置列表",
    "인터페이스 목록": "接口列表",
    "TLS 인증서 목록": "TLS 证书列表",
    "인증서명": "证书名称",
    "총 인증서:": "证书总数：",
    "활성:": "启用：",
    "비활성:": "停用：",
    "검색어": "关键字",
    "인터페이스명, 문서코드, 고객사 코드를 입력하세요": "请输入接口名称、文档代码或客户代码",
    "총 스케줄러:": "调度总数：",
    "실행중:": "运行中：",
    "중지됨:": "已停止：",
    "가동률:": "运行率：",
    "상태 새로고침": "刷新状态",
    "모두 시작": "全部启动",
    "모두 중지": "全部停止",
    "수신 문서": "接收文档",
    "송신 문서": "发送文档",
    "인터페이스를 선택하세요": "请选择接口",
    "인터페이스 ID 직접 입력": "直接输入接口 ID",
    "시작일": "开始日期",
    "종료일": "结束日期",
    "선택 일괄재시도": "重试所选项目",
    "수신실행": "执行接收",
    "송신실행": "执行发送",
    "인터페이스 지정": "指定接口",
    "수신 원문 데이터 목록이 없습니다.": "没有接收原始消息。",
    "송신 원문 데이터 목록이 없습니다.": "没有发送原始消息。",
    "인터페이스 타입을 입력하세요": "请输入接口类型",
    "조회기간": "查询期间",
    "총 건수:": "总条数：",
    "개발 도구 - Parser/Mapper 테스트": "开发工具 - Parser/Mapper 测试",
    "클래스 선택": "选择类",
    "테스트 실행": "执行测试",
    "테스트 중...": "测试中...",
    "테스트 Payload *": "测试 Payload *",
    "파싱할 데이터를 입력하세요...": "请输入要解析的数据...",
    "Parser 테스트": "Parser 测试",
    "Mapper 테스트": "Mapper 测试",
    "테이블 선택하세요": "请选择数据表",
    "테이블 선택": "选择数据表",
    "테이블을 선택하세요": "请选择数据表",
    "관리자 대시보드": "管理员仪表板",
    "전체 새로고침": "全部刷新",
    "오늘 트랜잭션 현황": "今日交易状态",
    "최근 30일 트랜잭션 현황": "最近 30 天交易状态",
    "수신 성공": "接收成功",
    "수신 실패": "接收失败",
    "송신 성공": "发送成功",
    "송신 실패": "发送失败",
    "오늘 수신 성공": "今日接收成功",
    "오늘 수신 실패": "今日接收失败",
    "오늘 송신 성공": "今日发送成功",
    "오늘 송신 실패": "今日发送失败",
    "월간 수신 성공": "每月接收成功",
    "월간 수신 실패": "每月接收失败",
    "월간 송신 성공": "每月发送成功",
    "월간 송신 실패": "每月发送失败",
    "최근 30일 수신 성공": "最近 30 天接收成功",
    "최근 30일 수신 실패": "最近 30 天接收失败",
    "최근 30일 송신 성공": "最近 30 天发送成功",
    "최근 30일 송신 실패": "最近 30 天发送失败",
    "최근 30일 트랜잭션 추이": "最近 30 天交易趋势",
    "일별 수신/송신 트랜잭션 성공/실패 현황입니다.": "每日接收与发送交易的成功及失败状态。",
    "데이터가 없습니다": "没有数据",
    "표시할 트랜잭션 통계가 없습니다.": "没有可显示的交易统计数据。",
    "최근 활동": "最近活动",
    "오늘 발생한 최신 실패 목록입니다.": "今日最新失败列表。",
    "모든 시스템이 정상입니다": "所有系统运行正常",
    "오늘 발생한 실패가 없습니다.": "今日没有发生失败。",
    "오류 메시지 없음": "没有错误消息",
    "시스템 상태": "系统状态",
    "각 모듈별 실시간 상태입니다.": "各模块的实时状态。",
    "전체 시스템": "整体系统",
    "장애": "异常",
    "정상": "正常",
    "수신 모듈": "接收模块",
    "송신 모듈": "发送模块",
    "오늘 성공": "今日成功",
    "오늘 실패": "今日失败",
    "미확인 수신 데이터": "未识别接收数据",
    "라우트가 지정되지 않은 수신 문서 목록입니다.": "尚未指定路由的接收文档列表。",
    "모든 문서가 정상 수신되었습니다.": "所有文档均已成功接收。",
    "미확인 수신 데이터가 없습니다.": "没有未识别接收数据。",
    "알 수 없는 인터페이스": "未知接口",
    "미분류": "未分类",
    "인터페이스:": "接口：",
    "수신 일시": "接收时间",
    "전체 보기": "查看全部",
    "이번 주 GenRes 목록": "本周 GenRes 列表",
    "이번 주 발생한 GenRes 데이터(최신순 5건)입니다.": "本周最新的 5 条 GenRes 数据。",
    "이번 주 데이터가 없습니다.": "本周没有数据。",
    "메시지명 없음": "没有消息名称",
    "성공률": "成功率",
    "건": " 条",
    "현재 확인이 필요한 문서가": "当前需要确认的文档有",
    "있습니다.": "。",
    "전체": "全部",
    "수신완료": "接收完成",
    "파싱 중": "解析中",
    "유효성 검사 중": "验证中",
    "매핑 중": "映射中",
    "DB 저장 중": "保存到数据库中",
    "처리 완료": "处理完成",
    "데이터생성": "数据已创建",
    "매핑": "映射",
    "송신 중": "发送中",
    "송신 완료": "发送完成",
    "ACKANS 성공": "ACKANS 成功",
    "ACKANS 실패": "ACKANS 失败",
    "인터페이스 완료": "接口处理完成",
    "처리실패": "处理失败",
    "성공": "成功",
    "에러": "错误",
    "컴포넌트": "组件",
    "아이프레임": "内嵌框架",
    "수신": "接收",
    "송신": "发送",
    "DATABASE인증": "数据库认证",
    "예": "是",
    "아니오": "否",
    "처리완료": "处理完成",
    "오류": "错误",
    "서버 인증(TLS)": "服务器认证 (TLS)",
    "인증서를 선택하세요": "请选择证书",
  },
};
